export default __webpack_public_path__ + "static/media/tutorial-03.d0fa71da.jpg";